// Guest-facing text sent as `gasttext` to Web3Forms with each booking.
// Keyed by activity. Fill in the texts from the guest-text list.
export const guestTexts: Record<string, string> = {
  'halloween-run-club': '',
  'halloween-hidden-reality': '',
  'halloween-barnens-dag': '',
  'halloween-monsterdisko': '',
  'halloween-hostbrunch': '',
  bordsbokning: '',
  eventforfragan: '',
}
